import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import {Avatar, Grid} from "@material-ui/core";
import avatarGirl from "./../../assets/images/avatar-girl.png"
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    }
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const {count, page, rowsPerPage, onChangePage} = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, calories, fat) {
    return {name, calories, fat};
}

// const rows = this.props.population;
// console.log(rows);

const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
    },
});

export default function CustomPaginationActionsTable({population}) {
    const rows = population;

    //get max Topics In Connection
    //IF THERE ISN'T ANY OBJECT INTO ARRAY
    //o.common_topics.length RETURNS -Infinity
    //HAVE TO FIX TO RETURN SMTH WHEN WE DECIDE THAT
    //WE NEED FROM COLUMNS
    // let maxTopicsInConnection = Math.max.apply(Math, population.map(function (o) {
    //         return o.common_topics.length;
    // }))

    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className='table__custom'>
            <TableContainer component={Paper}>
                <Table className={`${classes.table} fixed`} aria-label="custom pagination table">
                    <colgroup>
                        {/*colgroup CREATE LAYOUT FOR THE TABLE*/}
                        <col style={{width: 280}}/>
                        {/*LOOP TROUGH MAXIMUM NUMBER OF TOPICS IN CONNECTIONS
                        don't delete it. this should be fix if we need columns
                        @ToDo - maxTopicsInConnection returns -Infinity if there aren't any objects into arr
                        */}
                        {/*{[...Array(maxTopicsInConnection)].map((x, i) =>*/}
                        {/*    <col key={i} style={{width: 260}}/>*/}
                        {/*)}*/}
                    </colgroup>
                    <TableBody>
                        {(rowsPerPage > 0
                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : rows
                        ).map((row) => (
                            <TableRow key={row.id}>
                                <TableCell style={{width: 280}}>
                                    <Grid container spacing={2} justify='flex-start'
                                          alignItems={"center"}>
                                        <Grid item md={"auto"}>
                                            <Avatar alt={row.name} src={row.image_link? row.image_link : avatarGirl}
                                                    className='profile__wrap__content-avatar'/>
                                        </Grid>
                                        <Grid item md={"auto"} style={{flex: '1 1 0px'}}>
                                            {row.name}
                                        </Grid>
                                        <Grid item md={3} style={{marginLeft: 'auto'}}>
                                            <IconButton
                                                aria-label='LinkedInIcon'
                                                variant='link'
                                                // color='primary'
                                                target='_blank'
                                                href={`https://www.linkedin.com/in/${row.social.linkedin_url}`}
                                            >
                                                <LinkedInIcon
                                                    style={{
                                                        color: '#ffffff',
                                                        backgroundColor: '#0a66c2'
                                                    }}
                                                    fontSize='large'
                                                />
                                            </IconButton>

                                        </Grid>
                                    </Grid>
                                </TableCell>
                                {
                                    row.common_topics.map((topic, index) => {
                                        return (
                                            <TableCell key={index} style={{width: 260}} align="left">
                                                {topic.title}
                                            </TableCell>
                                        )
                                    })
                                }

                            </TableRow>
                        ))}

                        {emptyRows > 0 && (
                            <TableRow style={{height: 53 * emptyRows}}>
                                <TableCell colSpan={6}/>
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>

                        </TableRow>
                    </TableFooter>

                </Table>
            </TableContainer>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="custom pagination table">
                    <TableBody>
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, {label: 'All', value: -1}]}
                                colSpan={3}
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {'aria-label': 'rows per page'},
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>

                </Table>
            </TableContainer>
        </div>
    );
}
